import { useNavigate } from "react-router";
import {
  PATH_CONTACT,
  PATH_CONTACT_FORM,
  PATH_CONTACT_SECTION,
} from "../../../utility/constants";
import { CompanyInfoItemType } from "../../../utility/types/generaTypes";
import { COMPANY_INFO, WHY_CHOOSE_US } from "../../../utility/utilityData";
import Button from "../../common/buttons/button/Button";
import ContactUsForm from "../contactUsForm/ContactUsForm";
import GradientIcon from "../gradientIcon/GradientIcon";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./ContactSection.css";

type ContactSectionProps = {
  isHomepage?: boolean;
};
const ContactSection = ({ isHomepage }: ContactSectionProps) => {
  const navigate = useNavigate();
  return (
    <section id={PATH_CONTACT_SECTION} className="app_section">
      {isHomepage && (
        <div className="appSection_header_container">
          <SectionHeader title={`📞 Get In Touch`} />
          <h1 className="section_title">
            Let's Build Something{" "}
            <span className="gradient_text"> Amazing Together </span>
          </h1>
          <p className="section_description">
            Ready to transform your ideas into reality? We'd love to hear about
            your project and discuss how we can help bring your vision to life.
          </p>
        </div>
      )}
      <div className="contact_subContainer">
        <div className="contact_subContainer_leftPart">
          <h3>Get in Touch</h3>
          {COMPANY_INFO.map((info, index) => (
            <InfoCard key={"InfoCard" + index} info={info} />
          ))}
          <WhyChooseUsCard />
        </div>
        <div id={PATH_CONTACT_FORM} className="contact_subContainer_rightPart">
          <ContactUsForm />
        </div>
      </div>
      {isHomepage && (
        <div className="schedule_free_consultation_card gradient_bg">
          <h3>Ready to Transform Your Business?</h3>
          <p>
            Join 10+ satisfied clients who have transformed their digital
            presence with our expert team.
          </p>
          {/* <div className="free_consultation_btnContainer"> */}
          <Button
            title="Schedule Free Consultation"
            onClickButton={() => navigate(PATH_CONTACT)}
            backgroundColor="white"
            color="black"
            className="free_consultationBtn"
          />
          {/* <Button
              title="View Our Portfolio"
              path={"#" + PATH_PORTFOLIO_SECTION}
              pathType="_self"
              backgroundColor="white"
              className="view_ourPortfolio_Btn"
            />
          </div> */}
        </div>
      )}
    </section>
  );
};
type InfoCardProps = {
  info: CompanyInfoItemType;
};

const InfoCard = ({ info }: InfoCardProps) => {
  return (
    <div className="contact_infoCard_container">
      <GradientIcon
        src={info?.icon}
        alt={info?.title}
        mainContainerClassName={"contact_infoCard_img_container"}
      />
      <div className="contact_infoCard_container_leftPart">
        <h4>{info?.title}</h4>
        <p className="contact_infoCard_valueText">{info?.value}</p>
        <p className="contact_infoCard_descText">{info?.desc}</p>
      </div>
    </div>
  );
};
const WhyChooseUsCard = () => {
  return (
    <div className="whyChooseUsCard_container app_card">
      <h4>Why Choose JD SoftTech?</h4>
      {WHY_CHOOSE_US.map((item, index) => (
        <div
          className="whyChooseUs_points_container"
          key={"WHY_CHOOSE_US" + index}
        >
          <div className="point" />
          <p key={index}>{item}</p>
        </div>
      ))}
    </div>
  );
};

export default ContactSection;
